// extracted by mini-css-extract-plugin
module.exports = {"ratingBar":"StarRating_ratingBar__AV2dE","starIcon":"StarRating_starIcon__NblWR"};